import React from 'react';
import Button from '~/components/atom/Button';
import JustificationContainer from '~/components/atom/JustificationContainer';
import TextButton from '~/components/atom/TextButton';
import type { ServicesFeedbackType } from '~/components/page/LFA/state/servicesFeedbackState';
import type { InteractiveAppearance } from '~/styles/constants';

type Props = {
  servicesFeedback: ServicesFeedbackType;
  loading: boolean;
  onClick: () => void;
  onClose: () => void;
};

const Footer: React.FCC<Props> = ({
  onClick,
  servicesFeedback,
  onClose,
  loading,
}) => {
  const buttonAppearance: InteractiveAppearance =
    servicesFeedback?.Event_Feedback_Appointment_Failed
      ? 'danger'
      : servicesFeedback?.Event_Feedback_Snooze
        ? 'tertiary'
        : 'secondary';

  const buttonLabel = servicesFeedback?.Event_Feedback_Snooze
    ? 'Uitstellen'
    : servicesFeedback?.Event_Feedback_Appointment_Rescheduled
      ? 'Verzenden'
      : 'Update de status';

  return (
    <JustificationContainer
      align="center"
      width="100%"
      justification="space-between"
      padding={[null, 'xl', 'xl', 'xl']}
    >
      <TextButton
        size="medium"
        label="Annuleren"
        appearance="danger"
        padding={[null]}
        onClick={onClose}
      />
      <Button
        size="medium"
        loading={loading}
        disabled={loading}
        label={buttonLabel}
        onClick={onClick}
        appearance={buttonAppearance}
      />
    </JustificationContainer>
  );
};

export default Footer;
